import { useCallback, useEffect, useState } from "react";
import { selectionHistoryApi } from "src/Api/selectionHistory";

export function useTimesheetSelectionHistories(userId: number) {
  const [timesheetList, setTimesheetList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  if (!userId || userId === 0 ) return; 
  }, [userId]);

  // GET
  const fetchTimesheetList = useCallback(() => {
    if (!userId) return;
    setLoading(true);
    selectionHistoryApi.getTimesheetSelectionHistories(userId)
      .then(res => setTimesheetList(res.data.data))
      .finally(() => setLoading(false));
  }, [userId]);

  useEffect(() => { fetchTimesheetList(); }, [fetchTimesheetList]);

  // POST（保存&リスト取得）
  const storeTimesheetSelection = useCallback(async (body: any) => {
    await selectionHistoryApi.storeTimesheetSelectionHistory(body);
    fetchTimesheetList(); 
  }, [fetchTimesheetList]);

  return { timesheetList, loading, storeTimesheetSelection, fetchTimesheetList };
}
